module.exports = __webpack_public_path__ + "img/pinganBanner.09dac0cc.png";